<template>
  <div class="floorRecommend">
    <el-button
      type="primary"
      size="mini"
      @click="handleAdd"
      style="margin-top: 10px"
      >新增</el-button
    >
    <el-button type="primary" size="mini" @click="onShowSkuCoverSetting" style="margin-top: 10px">店铺&商品推荐补位</el-button>
    <el-button type="primary" size="mini" @click="onShowProductCoverSetting" style="margin-top: 10px">商品推荐补位</el-button>
    <div class="floor-box">
      <div v-for="(item, index) in goodsData" :key="index">
        <div class="floor-box-top">
          <span class="floor"> {{ index + 1 }}层</span>
          <el-button
            type="primary"
            size="mini"
            @click="handleDeleteFloor(item.floorList[0].floor)"
            style="margin-top: 10px"
            >删除该层</el-button
          >
        </div>
        <el-table
          :data="item.floorList"
          highlight-current-row
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column
            prop="priceRange"
            label="类型"
            align="center"
            width="110"
          >
            <template slot-scope="scope">
              {{ scope.row.shopId ? "店铺&商品推荐" : "商品推荐" }}
            </template>
          </el-table-column>
          <!-- <el-table-column type="index" label="序号" width="80" align="center" /> -->
          <el-table-column type="sort" label="序号" width="80" align="center" >
            <template slot-scope="scope">
              <div class="merchant-name">
                <span class="name">{{ scope.row.sort }}</span>
                <span v-if="scope.row.id">
                  <i
                    class="el-icon-edit"
                    style="margin-left: 10px"
                    @click="handleClickSort(scope.row)"
                  ></i> 
                </span>
              </div>
            </template>
        </el-table-column>
          <el-table-column label="商品信息" align="center" width="500">
            <template slot-scope="scope">
              <div
                class="goods-info"
                v-if="
                  scope.row.goodsSkuTitle ||
                  scope.row.specification ||
                  scope.row.factory ||
                  scope.row.approvalNumber
                "
              >
                <img
                  class="goods-info-left"
                  :src="scope.row.goodsSkuImage || avater"
                  alt=""
                />
                <div class="goods-info-right">
                  <p class="color-26 text-ellipsis">{{ scope.row.goodsSkuTitle }}</p>
                  <p class="color-26 text-ellipsis">{{ scope.row.factory }}</p>
                  <p class="color-26">{{ scope.row.specification }}</p>
                  <p class="color-26">{{ scope.row.approvalNumber }}</p>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="priceRange" label="价格" align="center" />
          <el-table-column
            prop="saleShopCount"
            label="在售商家"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <div class="sale-shop-count">
                <span class="count" v-if="scope.row.shopId">1</span>
                <span class="count" v-else>{{ scope.row.saleShopCount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="指定商户"
            align="center"
          />
          <el-table-column prop="priceRange" label="店铺信息" align="center">
            <template slot-scope="scope">
              <div class="shop-info">
                <img
                  v-if="scope.row.shopLogo"
                  :src="scope.row.shopLogo"
                  alt=""
                />
                <p>{{ scope.row.shopName }}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="160"
            fixed="right"
          >
            <template slot-scope="scope">
              <p
                @click="handleEdit(scope.row, index)"
                style="cursor: pointer; margin-right: 10px"
              >
                {{ scope.row.shopId ? "选择商户及商品" : "选择商品" }}
            </p>
              <p
                @click="handleDelete(scope.row)"
                :style="{
                  color: scope.row.add ? 'gray' : 'red',
                  cursor:scope.row.add ? 'not-allowed' : 'pointer',
                }"
                >删除</p
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 新增/编辑 -->
    <DlgAddGoods
      ref="addGoodsRef"
      :type="goodsType"
      :show-shop="showShop"
      :floor="floor"
      @refreshList="getGoodsList"
    />
     <!-- SKU补位设置 -->
     <el-dialog title="SKU补位设置" :visible.sync="showSkuCoverSetting" width="70%" @close="onCloseSkuCoverSetting">
      <FloorSkuCoverSetting :visible.sync="showSkuCoverSetting"/>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCloseSkuCoverSetting">取消</el-button>
      </span>
    </el-dialog>
     <!-- 商品推荐补位设置 -->
     <el-dialog title="商品补位设置" :visible.sync="showProductCoverSetting" width="70%" @close="onCloseProductCoverSetting">
      <FloorProductCoverSetting  :visible.sync="showProductCoverSetting"/>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="onCloseProductCoverSetting">取消</el-button>
      </span>
    </el-dialog>  
    <setSort ref="setSort"  @refreshList="getGoodsList" />

  </div>
</template>

<script>
import avater from "/public/img/default.png";
import {
  getFloorRecommendShopList,
  addRecommendGoods,
  updateRecommendGoods,
  deleteRecommendGoods,
  deleteFloorRecommendGoods,
} from "@/api/recommendationHome";
import DlgAddGoods from "../components/dlgAddGoods";
import FloorSkuCoverSetting from "../components/floorSkuCoverSetting.vue";
import FloorProductCoverSetting from "../components/floorProductCoverSetting.vue";
import setSort from "../components/setSort";

export default {
  components: {
    DlgAddGoods,
    FloorSkuCoverSetting,
    FloorProductCoverSetting,
    setSort
  },
  data() {
    return {
      avater: avater,
      showShop: false,
      goodsType: 3,
      originGoodsData: [],
      goodsData: [],
      floor: 0,
      pageSizes: [],
      showSkuCoverSetting: false,
      showProductCoverSetting: false
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getGoodsList();
  },
  mounted() {},
  beforeCreate() {},
  beforeMount() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  activated() {},
  methods: {
    handleClickSort(row) {
      this.$refs.setSort.show(row,'goods');
    },
    handleAdd() {
      // 新的 floorList 数据
      const { originGoodsData } = this;
      const floor =
        originGoodsData.length > 0
          ? Number(
              originGoodsData[originGoodsData.length - 1]?.floorList[0]
                ?.floor || originGoodsData[0]?.floorList[0]?.floor
            ) + 1
          : 1;
      console.log("新增的楼层", floor);
      let newFloorList = [
        { shopId: 1, add: true, floor: floor },
        { shopId: 2, add: true, floor: floor },
        { shopId: 3, add: true, floor: floor },
        { shopId: null, add: true, floor: floor },
        { shopId: null, add: true, floor: floor },
        { shopId: null, add: true, floor: floor },
        { shopId: null, add: true, floor: floor },
        { shopId: null, add: true, floor: floor },
      ];

      this.goodsData.push({ floorList: newFloorList });

      // 滚动到底部
      this.$nextTick(() => {
        const floorBox = document.querySelector(".floor-box");
        floorBox.scrollTop = floorBox.scrollHeight;
      });
    },
    handleEdit(row, index) {
      const list = this.goodsData[index].floorList.filter((i) => !i.add);
      this.floor = list.length
        ? list[0].floor
        : this.goodsData[index].floorList[0].floor;
      this.showShop = row.shopId ? true : false;
      this.$refs.addGoodsRef.id = row.id;
      this.$refs.addGoodsRef.shopId = row.shopId;
      this.$refs.addGoodsRef.shopName = row.merchantName;
      this.$refs.addGoodsRef.dialogVisible = true;
    },
    getGoodsList() {
      // 每层必须有8层 没有商品的补空
      getFloorRecommendShopList({ type: this.goodsType }).then((res) => {
        if (res.code == 0) {
          // res.data.forEach((floor) => {
          //   floor.floorList.sort((a, b) => {
          //     if (a.flor < b.flor) {
          //       return -1;
          //     }
          //     if (a.flor > b.flor) {
          //       return 1;
          //     }
          //     return 0;
          //   });
          // });
          this.originGoodsData = res.data;
          const _floor =
            res.data.length && res.data[0].floorList.length
              ? res.data[0].floorList[0].floor
              : 1;
          res.data.forEach((floor) => {
            let shopCount = 0;
            let goodsCount = 0;
            let lastShopIdIndex = -1;
            floor.floorList.forEach((item, index) => {
              if (item.shopId !== null && item.shopId !== undefined) {
                shopCount++;
                lastShopIdIndex = index;
              } else {
                goodsCount++;
              }
            });

            if (shopCount < 3) {
              // 一层有且必须有3个店铺
              while (shopCount < 3) {
                floor.floorList.splice(lastShopIdIndex + 1, 0, {
                  shopId: 1,
                  add: true,
                  floor: _floor,
                });
                shopCount++;
              }
            }

            if (goodsCount < 5) {
              // 一层有且必须有5个商品
              while (goodsCount < 5) {
                floor.floorList.push({
                  shopId: null,
                  add: true,
                  floor: _floor,
                });
                goodsCount++;
              }
            }
          });
          this.goodsData = [...res.data];
        }
      });
    },
    handleDeleteFloor(floor) {
      console.log("确认删除该层?", floor);
      this.$confirm("确认删除该层?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return !floor ? null : deleteFloorRecommendGoods(floor);
        })
        .then(() => {
          this.getGoodsList();
          this.$message.success("删除成功");
        });
    },
    handleDelete(row) {
      if (row.add) return;
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteRecommendGoods(row.id);
        })
        .then(() => {
          this.getGoodsList();
          this.$message.success("删除成功");
        });
    },
   /** sku补位设置 */
    onShowSkuCoverSetting() {
      this.showSkuCoverSetting = true
    },
    /**关闭sku补位设置 */
    onCloseSkuCoverSetting() {
      this.showSkuCoverSetting = false
    },
    /** 商品推荐补位设置 */
    onShowProductCoverSetting() {
      this.showProductCoverSetting = true
    },
    /**关闭商品推荐补位设置 */
    onCloseProductCoverSetting() {
      this.showProductCoverSetting = false
    },
  },
};
</script>
<style lang="scss" scoped>
.floorRecommend {
  .floor-box {
    height: calc(100vh - 270px);
    overflow: auto;
    &-top {
      margin: 10px 0;
      .floor {
        margin-right: 20px;
        font-weight: 600;
      }
    }
    .goods-info {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      &-left {
        display: block;
        width: 60px;
        height: 60px;
        margin-right: 10px;
      }
      &-right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 360px;
        .text-ellipsis {
          max-width:360px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      p {
        margin: 0;
        height: 18px;
      }
      .color-26 {
        color: #262626;
      }
    }
    .shop-info {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        display: block;
        width: 60px;
        height: 60px;
      }
      p {
        margin: 5px 0 0 0;
      }
    }
  }
}
</style>
